import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <span className="font-heading text-3xl text-background-50">韩漫之家</span>
            <p className="mt-6 text-foreground-300 text-sm leading-relaxed max-w-xs">
              免费韩漫大全，支持韩国漫画下拉式在线阅读。汇集热血、恋爱、奇幻、悬疑、搞笑等全类型韩漫，从经典到新作一应俱全，满足您对韩漫的所有期待与热爱。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider">快速导航</h4>
            <div className="mt-5 flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">首页</Link>
              <Link to="/category/rexue" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">热血漫画</Link>
              <Link to="/category/lianai" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">恋爱漫画</Link>
              <Link to="/category/qihuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">奇幻漫画</Link>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider">热门分类</h4>
            <div className="mt-5 flex flex-col gap-3">
              <Link to="/category/xuanyi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">悬疑漫画</Link>
              <Link to="/category/gaoxiao" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">搞笑漫画</Link>
              <Link to="/category/xiaoyuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">校园漫画</Link>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider">关于我们</h4>
            <div className="mt-5 flex flex-col gap-3">
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">品牌介绍</Link>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">用户协议</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">隐私政策</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">版权声明</a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider">联系方式</h4>
            <div className="mt-5 flex flex-col gap-3">
              <p className="text-sm text-foreground-400">邮箱：hello@uyeqdpvovrg.cn</p>
              <p className="text-sm text-foreground-400">客服QQ：800123456</p>
              <p className="text-sm text-foreground-400">工作时间：9:00 - 22:00</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 韩漫之家 版权所有 | 本站所有漫画均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}